import { Directive, HostBinding } from '@angular/core'

@Directive({
  selector: '[libCardAction]',
})
export class CardActionDirective {
  @HostBinding('class')
  get cardAction() {
    return 'card-action'
  }
}
